import { Eyebrow, MaskLines, Reveal } from "@/components/site/Motion";

const STEPS = [
  ["Você contrata ou propõe o evento", "Organizador, empresa ou família: combine a data e o valor por foto. A cobertura não custa nada para o evento."],
  ["Fotografamos tudo", "Um fotógrafo associado registra cada momento e publica a galeria com prévias protegidas por marca d'água."],
  ["Cada pessoa encontra suas fotos", "Os participantes entram no site, buscam o evento e selecionam as fotos em que aparecem."],
  ["Pagou, baixou", "Pagamento antecipado via Pix ou Mercado Pago. Confirmado o pagamento, os originais em alta são liberados."],
];

export const HowItWorks = () => (
  <section id="como-funciona" className="relative border-t border-white/10 py-24 lg:py-32" data-testid="how-it-works-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Eyebrow>Como funciona</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[0.95] tracking-tight sm:text-6xl">
            <MaskLines animateOnMount={false} lines={["Quatro passos", "do clique", <span key="c" className="text-flash">ao download.</span>]} />
          </h2>
        </div>
      </div>
      <ol className="lg:col-span-7">
        {STEPS.map(([t, d], i) => (
          <Reveal as="li" key={t} delay={i * 0.05} className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-10 last:border-b sm:gap-10">
            <span className="font-display text-5xl font-extrabold text-outline transition-colors duration-500 group-hover:text-flash sm:text-7xl" style={{ WebkitTextStrokeColor: "rgba(255,107,0,0.7)" }}>
              0{i + 1}
            </span>
            <div className="pt-2">
              <h3 className="font-display text-2xl font-bold sm:text-3xl">{t}</h3>
              <p className="mt-3 max-w-lg text-haze">{d}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
